<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_DataFill')"
    width="1300px"
    :show-close="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    class="custom-form-dialog"
  >
    <ai-custom-page-data-view
      v-if="innerVisible"
      :form-config="formConfig"
      :page-parts="pageParts"
      :debug="false"
      :readonly="readonly"
      :job-uuid="derivedJob.uuid"
      :job="derivedJob"
      :jobs="jobs"
      :tenant-instructions="tenantInstructions"
      @saveSuccess="$emit('callback')"
      @close="innerVisible=false"
    />
  </el-dialog>
</template>

<script>
import aiCustomPageDataView from '@/views/cargo/v0/SystemMaintenance/components/aiCustomPage/aiCustomPageDataView'

export default {
  name: 'CustomFormDialog',
  components: { aiCustomPageDataView },
  props: {
    visible: { type: Boolean, required: true },
    formConfig: { type: Object, required: true },
    pageParts: { type: Array, required: true },
    job: { type: Object, default: null },
    jobs: { type: Array, default: () => [] },
    tenantInstructions: { type: Array, default: () => [] }
  },
  data() {
    return {
      innerVisible: false,
      readonly: true
    }
  },
  computed: {
    // 自动派生job对象
    derivedJob() {
      return this.job || (this.jobs && this.jobs.length > 0 ? this.jobs[0] : {})
    }
  },
  watch: {
    visible: {
      immediate: true,
      async handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          this.$nextTick(() => {
            this.readonly = false
          })
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.readonly = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-form-dialog::v-deep {
  // z-index: 9999 !important;
  .el-dialog {
    margin-top: 5vh !important;
    top: 0 !important;
    .el-dialog__body {
      padding: 0 !important;
    }
  }
}
</style>
